import TaskError from '@/common/utils/errors/TaskError';
import socketio from '@/common/utils/socketio.connection';
import { BackendTask, TaskState } from '@schema';
import useTasksStore from '@/common/store/pinia/tasks';
import CancellationError from './errors/CancellationError';

// TODO: move to vuex plugins; replace BackendTask state to TaskState
export function waitTask(task: BaseResponse<CreateFetchResponse, { task_id: string }> | string) {
  const id = typeof task === 'string' ? task : task.data.task_id;

  return new Promise(((resolve, reject) => {
    const callback = function (taskResponse: BackendTask) {
      if (taskResponse.task_id === id) {
        switch (taskResponse.state) {
          case TaskState.SUCCESS:
            socketio.off('tasks', callback);
            resolve(taskResponse);
            break;
          case TaskState.CANCELLED:
            socketio.off('tasks', callback);
            reject(new CancellationError());
            return;
          case TaskState.FAILED:
            socketio.off('tasks', callback);
            reject(new TaskError(taskResponse));
            break;
          default:
            break;
        }
      }
    };

    socketio.on('tasks', callback);

    const tasksStore = useTasksStore();
    const existedTask = tasksStore.getItemById(id);
    if (existedTask) {
      callback(existedTask);
    }
  }));
}

export default waitTask;
